import { createUseEventCallbackWithoutBuilder } from './create-use-event-callback-without-builder';
import { useEventCallback } from './use-event-callback';

export const useEventCallbackWithoutBuilder = createUseEventCallbackWithoutBuilder({
    useEventCallback,
});
